

import logo64 from '../logo';

const stylesTemplate = {
    template: {

        rodapeTexto: {
            fontSize: 10,
        }
    },
    relatorioTitulo: {
        fontSize: 20,
        bold: true,
    },
    cabecalhoTexto1: {
        fontSize: 18,
        bold: true,
    },
    cabecalhoTexto2: {
        fontSize: 12,
        bold: false,

    },
    cellTitulo: {
        marginBottom: 1,
        marginLeft: 1,
        marginRight: 1,
        marginTop: 1,

        fontSize: 9,
        bold: true,
        fillColor: '#dcdcdc',
    },

    cellValor: {
        marginBottom: 1,
        marginLeft: 1,
        marginRight: 1,
        marginTop: 1,
        fontSize: 9,
        fillColor: '#f0f0f0',
    },
    cellLimpo: {
        marginBottom: 1,
        marginLeft: 1,
        marginRight: 1,
        marginTop: 1,
        fontSize: 9,
    },
    fieldsetTitulo: {

        marginBottom: 2,
        marginLeft: 2,
        marginRight: 2,
        marginTop: 2,
        fontSize: 11,
        bold: true,
        fillColor: '#285137',
        color: 'white'
    }
}

export function gerarDocumento(okReport, conteudo, meta,jsonDados) {
    let tituloRelatorio = "Titulo Relatorio"
    let textoCabecalho1 = ""
    let textoCabecalho2 = ""
    let textoRodape1 = ""
    let textoRodape2 = ""

    let stylesUsar = stylesTemplate;

    const { styles, nome } = okReport
    if (styles) {
        stylesUsar = { ...stylesUsar, ...styles }
    }
    if (nome)
        tituloRelatorio = nome;

    let imageLogo = logo64;
    if (meta) {
        if (meta.logo) {
            // imageLogo = `data:image/png;base64,${meta.logo}`;
            imageLogo = meta.logo;
        }
        if (meta.tituloRelatorio) {
            tituloRelatorio = meta.tituloRelatorio
        }
        textoCabecalho1 = meta.textoCabecalho1
        textoCabecalho2 = meta.textoCabecalho2
        textoRodape1 = meta.textoRodape1
        textoRodape2 = meta.textoRodape2
    }

    const documentImprimir = templatePadrao(conteudo,
        {
            icone: imageLogo,
            tituloRelatorio,
            textoCabecalho1,
            textoCabecalho2,
            textoRodape1,
            textoRodape2,

        }, stylesUsar, meta, okReport
    );
    return documentImprimir
}


function cabecalhoPadrao(templateDados, currentPage, pageCount, pageSize, style) {
    return [{
        margin: [25, 10, 25, 0],
        table: {
            widths: [100, '*'],
            body: [
                [
                    {
                        border: [false, false, false, true],
                        alignment: 'center',
                        image: templateDados.icone,
                        width: 90,
                        height: 90,
                    },
                    {
                        border: [false, false, false, true],
                        table: {
                            body: [
                                [{
                                    text: templateDados.tituloRelatorio,
                                    style: style.relatorioTitulo,
                                }],
                                [{
                                    text: templateDados.textoCabecalho1,
                                    style: style.cabecalhoTexto1
                                }],
                                [{
                                    text: templateDados.textoCabecalho2,
                                    style: style.cabecalhoTexto2
                                }],
                            ]
                        }, layout: 'noBorders'
                    }
                ]
            ]
        }
    }]
}

export function templatePadrao(conteudo, templateDados, styles, meta, okReport) {

    var top = 120;
    const documentDefinition = {
        pageMargins: okReport.pageMargins || [25, top, 25, 55],
        pageSize: okReport.pageSize || 'A4',
        pageOrientation: okReport.pageOrientation || 'portrait',

        header: function (currentPage, pageCount, pageSize) {
            return cabecalhoPadrao(templateDados, currentPage, pageCount, pageSize, styles)
        },

        footer: function (currentPage, pageCount) {
            return [{
                margin: [25, 10, 25, 0],
                table: {
                    widths: ['*', "auto", 60],
                    body: [
                        [
                            {
                                border: [false, true, false, false],
                                text: templateDados.textoRodape1,
                                style: styles.template.rodapeTexto
                            },
                            {
                                border: [false, true, false, false],
                                text: templateDados.textoRodape2,
                                style: styles.template.rodapeTexto
                            },
                            {
                                border: [false, true, false, false],
                                alignment: 'right',
                                text: 'Pág.: ' + currentPage.toString() + '/' + pageCount,
                                style: styles.template.rodapeTexto
                            }

                        ]
                    ],

                }
            }]
        },
        content: conteudo,
        styles: styles,

    };

    return documentDefinition;
}